// services/removeFromCartService.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

// Define the remove from cart API URL, adding the product_id dynamically
const removeFromWishlistUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.removeFromWishlist}`;

const removeFromWishlistService = async (product_id) => {
  try {
    const response = await axios.delete(
      `${removeFromWishlistUrl}/${product_id}`,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );
    return response.data; // Return the response for further handling
  } catch (error) {
    console.error("Error removing product from cart:", error);
    throw error; // Throw the error for rejection in the async thunk or component
  }
};

export { removeFromWishlistService };
